import { RepresentativesFormFields } from './types';

/**
 * Дефолтный представитель используемый
 * при созданнии нового представителя
 */
export class DefaultRepresentativesItem implements RepresentativesFormFields {
  public id: string = `new-representative-${Math.random()}`;
  public fullName: string = '';
  public email: string = '';
  public accessRight: number = undefined;
  public workingWithApplications: number = undefined;
}
